<template>
    <div class="lesson_left" :class="{mb: mobile}">
        <!-- Title: Course name -->
        <div class="_title" v-if="!mobile">
            <span style="-webkit-line-clamp: 2 !important; -webkit-box-orient: vertical !important;">{{ course.name }}</span>
        </div>

        <div class="_title mb" v-if="mobile">
            <span>{{ course.name }}</span>
            <div class="div-img" @click="setShowMenu(!showMenu)">
                <img src="/static/images/closeMenu.png">
            </div>
        </div>

        <!-- Container -->
        <div class="_container">
            <!-- Top: catalogue -->
            <div class="top">
                <!-- Menu-->
                <div class="catalogue_menu" @click="tabType = $CONST.VIDEO.CONTENT_TYPE.MENU" :class="{'activeType': tabType == $CONST.VIDEO.CONTENT_TYPE.MENU}">
                    <span>{{$t("read.catalogue")}}</span>
                </div>

                <!-- Menu-->
                <div class="catalogue_note" @click="tabType = $CONST.VIDEO.CONTENT_TYPE.NOTEBOOK" :class="{'activeType': tabType == $CONST.VIDEO.CONTENT_TYPE.NOTEBOOK}">
                    <span>{{$t("read.note")}}</span>
                </div>

                <!-- Menu-->
                <div class="catalogue_chat" @click="tabType = $CONST.VIDEO.CONTENT_TYPE.MESSENGER" :class="{'activeType': tabType == $CONST.VIDEO.CONTENT_TYPE.MESSENGER}">
                    <span>{{$t("read.chat")}}</span>    
                </div>
            </div>

            <!-- Content -->
            <div class="content" id="treeView">
                <!-- Menu -->
                <menuLearn v-if="tabType == $CONST.VIDEO.CONTENT_TYPE.MENU" :course="data"></menuLearn>

                <!-- Note -->
                <noteLearn v-if="tabType == $CONST.VIDEO.CONTENT_TYPE.NOTEBOOK" :course="data"></noteLearn>

                <!-- Chat -->
                <chatLearn v-if="tabType == $CONST.VIDEO.CONTENT_TYPE.MESSENGER" :course="data"></chatLearn>
            </div>
        </div>
    </div>
</template>

<script>
    import menuLearn from '@/components/learn/menu.vue'
    import chatLearn from '@/components/learn/chat.vue'
    import noteLearn from '@/components/learn/note.vue'
    import { mapState, mapMutations } from "vuex"

    export default {
        data() {
            return {
                tabType: null
            };
        },
        props: {
            course: {
                type: Object,
                default: {},
            }
        },
        components: {menuLearn, noteLearn, chatLearn},
        created() {
            this.init();
        },
        watch: {
            activeID (newID) {
                if (this.tabType != this.$CONST.VIDEO.CONTENT_TYPE.MENU) {
                    this.tabType = this.$CONST.VIDEO.CONTENT_TYPE.MENU;
                }
            }
        },
        computed: {
            ...mapState({
                activeID: (state) => state.learn.activeID,
                mobile: (state) => state.header.mobile,
                showMenu: (state) => state.learn.showMenu
            }),

            data () {
                let course = this.course;
                course.activeID = this.activeID != null ? this.activeID : course.activeID;
                return course;
            }
        },
        methods: {
            init: function () {
                if (this.course.redirectType == 1) {
                    this.tabType = this.$CONST.VIDEO.CONTENT_TYPE.MESSENGER;
                    if (this.mobile) {
                        this.setShowMenu(!this.showMenu);
                    }
                } else {
                    this.tabType = this.$CONST.VIDEO.CONTENT_TYPE.MENU;
                }
            },

            ...mapMutations("learn", ["setActiveID", "setReload", "setShowMenu"]),
        }
    };
</script>

<style scoped>    
    /* Scroll */
    #treeView::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
        border-radius: 10px;
    }

    #treeView::-webkit-scrollbar {
        width: 5px;
        background-color: #ffffff;
        border-radius: 0 10px 10px 0;
    }

    #treeView::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    .content {
        height: calc(100% - 40px);
        overflow: auto;
    }
    .lesson_left, ._title, ._container, .top, .content {
        width: 100%;
    }
    .lesson_left {
        height: 100%;
    }
    .lesson_left.mb {
        padding: 1%;
    }
    ._title {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ._title.mb div-img{
        width: 20%;
    }
    ._title.mb div-img img{
        width: 46px;
        margin: auto;
    }
    ._title.mb span {
        width: 80%;
    }
    ._title span {
        font-size: 24px;
        font-weight: 700;
        color: #0071c5;
        line-height: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    ._container {
        width: 100%;
        height: calc(100% - 60px);
        border-radius: 5px;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.45);
    }
    .top {
        height: 40px;
        display: flex;
        cursor: pointer;
    }
    .top > div {
        flex: 33.33%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 2px solid gray;
        transition: ease 0.5s;
    }
    .catalogue_menu span, .catalogue_note span, .catalogue_chat span {
        font-size: 16px;
        font-weight: 700;
        color: gray;
        transition: ease 0.5s;
    }
    .top > div:hover span {
        color: #0071c5;
    }
    .top > div.activeType {
        border-bottom-color: #0071c5 !important;
    }
    .top > div.activeType span{
        color: #0071c5;
    }
</style>



// WEBPACK FOOTER //
// src/components/learn/left.vue